var exports = {
  "k": "xdde3148b--989bba--container",
  "v": "xdde3148b--989bba--inner",
};

module.exports = exports;
